import { render, staticRenderFns } from "./BoothBase.vue?vue&type=template&id=07738d72&"
import script from "./BoothBase.vue?vue&type=script&lang=js&"
export * from "./BoothBase.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports